export class CartItem {
    petName: string;
    productTotal: number;
}